import { useEffect } from 'react';

import { useSkipLinks } from '@evinced-private/ui-common';

import { RoutesHelper } from 'src/helpers/RoutesHelper';
import { useNavigation } from 'src/providers/navigationProvider/NavigationProvider';

export function useRouteRegistration(propertyId: string): void {
	const { setCurrentRoute } = useNavigation();

	useSkipLinks(true);

	useEffect(() => {
		if (propertyId) {
			setCurrentRoute({
				id: `advanced-settings-${propertyId}`,
				url: RoutesHelper.getPropertySettingsPagePath(propertyId),
				title: 'Advanced settings'
			});
		}
		return () => {
			setCurrentRoute(null);
		};
		// propertyId is stable (parent remounts via key={propertyId})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}
